/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'confluence.error.panel.refresh.app': 'Päivitä sovellus',
  'confluence.error.panel.reload.page': 'Lataa sivu uudelleen',
  'confluence.icon.label': 'Kuvake',
  'confluence.modal.dialog.close.modal.button': 'Peruuta',
  'confluence.select.required.field.message': 'Tämä kenttä on pakollinen.',
  'confluence.text.area.required.field.message': 'Tämä kenttä on pakollinen.',
  'confluence.textfield.validator.email': 'Anna kelvollinen sähköpostiosoite.',
  'confluence.textfield.validator.number': 'Anna kelvollinen numero',
  'confluence.textfield.validator.required.field.message': 'Tämä kenttä on pakollinen.',
  'confluence.textfield.validator.telephone': 'Anna kelvollinen puhelinnumero.',
  'confluence.threeLOPrompt.modal.access.required.title': 'Käyttöoikeus vaaditaan',
  'confluence.threeLOPrompt.modal.error.title': 'Virhe',
  'confluence.threeLOPrompt.modal.no.authURL.error-message':
    'Suostumuksen URL-osoitetta ei löydy. Päivitä sivu ja yritä uudelleen.',
  'confluence.threeLOPrompt.no.authURL.error-message':
    'Suostumuksen URL-osoitetta ei löydy. Päivitä sivu ja yritä uudelleen.',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'Salli pääsy',
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'Määritä käyttöoikeus',
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Todennus epäonnistui.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    'Jotta {appString} voidaan näyttää, sinun on sallittava sovelluksen käyttää Atlassian-tuotteita puolestasi.',
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message': '{appString} vaatii lisää käyttöoikeuksia tiliisi.',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': 'Ulkoisen todennuksen varoitus',
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'tämä sovellus',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'Tämä sovellus',
  'confluence.user.group.unknown.user.message': 'Tuntematon käyttäjä',
  'confluence.user.picker.empty.field.error.message': 'Tämä kenttä on pakollinen.',
  'confluence.user.unknown.user.message': 'Tuntematon käyttäjä',
  'forge-ui.form.submit-button.text': 'Lähetä',
};
